import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '../commons/abstract.service';
import { CampaignAudienceFile } from '../models/campaign-audience-file.model';

@Injectable({ providedIn: 'root' })
export class CampaignAudienceFileService extends AbstractService<CampaignAudienceFile> {

  getURLBase(): string {
    return '/campaign-audience-file';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(audienceFile: CampaignAudienceFile): void {
    delete audienceFile._id;
  }

  preUpdate(audienceFile: CampaignAudienceFile): void {
  }

  /**
   * Lists reusable audience files for the "reuse a list already sent" card.
   * Defaults to a recent window server-side; `all` asks for the full history.
   */
  listAvailable(all = false): Observable<Array<CampaignAudienceFile>> {
    return super.getWithParams('/list', all ? { all: 'true' } : {});
  }

}
